import { Route } from '@angular/router';
import { Path } from '../../common/constants/paths.constant';
import { HomeComponent } from './home/home.component';

export const landingRoutes: Route[] = [
  {
    path: Path.HOME,
    component: HomeComponent,
  },
  {
    path: Path.ABOUT,
    loadComponent: () =>
      import('../../pages/landing/about/about.component').then(
        c => c.AboutComponent
      ),
  },
  {
    path: Path.FEATURES,
    loadComponent: () =>
      import('../../pages/landing/features/features.component').then(
        c => c.FeaturesComponent
      ),
  },
  {
    path: Path.BECOME_SUPPLIER,
    loadComponent: () =>
      import('../../pages/landing/become-supplier/become-supplier.component').then(
        c => c.BecomeSupplierComponent
      ),
  },
  {
    path: Path.CONTACT_US,
    loadComponent: () =>
      import('../../pages/landing/contact-us/contact-us.component').then(
        c => c.ContactUsComponent
      ),
  },
];
